import { render, staticRenderFns } from "./index.vue?vue&type=template&id=761fbe88&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761fbe88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\User\\Documents\\legalmerge-prod\\legal-merge\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('761fbe88')) {
      api.createRecord('761fbe88', component.options)
    } else {
      api.reload('761fbe88', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=761fbe88&scoped=true", function () {
      api.rerender('761fbe88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ScreenPop/index.vue"
export default component.exports